import React from 'react';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '&:hover fieldset': {
      borderColor: '#1a237e',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1a237e',
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#1a237e',
    },
  },
}));

export default StyledTextField; 